import { render, staticRenderFns } from "./box_d.vue?vue&type=template&id=6fc9b9c5&scoped=true"
import script from "./box_d.vue?vue&type=script&lang=js"
export * from "./box_d.vue?vue&type=script&lang=js"
import style0 from "./box_d.vue?vue&type=style&index=0&id=6fc9b9c5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fc9b9c5",
  null
  
)

export default component.exports